import { type PropsWithChildren } from "react";
import Box from "@mui/material/Box";
import Fade from "@mui/material/Fade";
import LinearProgress from "@mui/material/LinearProgress";

export interface AppShellProps extends PropsWithChildren {
  loading?: boolean;
}

export function AppShell({ children, loading }: AppShellProps) {
  return (
    <Box sx={{ height: "100%" }}>
      <Box sx={{ position: "absolute", top: 0, left: 0, right: 0 }}>
        <Fade in={loading}>
          <LinearProgress />
        </Fade>
      </Box>
      {children}
    </Box>
  );
}
